import afilliationSummary from './afilliation-summary';
import afilliationSummaryVirtual from './afilliation-summary-virtual';
import bankAccountData from './bank-account-data';
import businessData from './business-data';
import agentData from './agent-data';
import businessSchedule from './business-schedule';
import installationSchedule from './installation-schedule';
import membershipRequirements from './membership-requirements';
import osvType from './osv-type';
import registerPlataform from './register-plataform';
import virtualCommerceData from './virtual-commerce-data';
import productChoice from './product-choice';
import reportChoice from './report-choice';
import representativeData from './representative-data';
import rucValidations from './ruc-validations';
import terms from './terms';
import termsmultiAdress from './terms-multiAdress';
import rejectAffiliation from './reject-affiliation';
import onHoldAffiliation from './on-hold-affiliation';

export { afilliationSummary, afilliationSummaryVirtual, bankAccountData, businessData, agentData, businessSchedule, installationSchedule, membershipRequirements, osvType, productChoice, representativeData, rucValidations, terms, termsmultiAdress, registerPlataform, virtualCommerceData, rejectAffiliation, onHoldAffiliation, reportChoice };


//////////////////
// WEBPACK FOOTER
// ./src/components/stepper/index.js
// module id = ./src/components/stepper/index.js
// module chunks = 0 1 2 3